import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiLink, { LinkProps } from "@mui/material/Link";

const StyledLink = styled(MuiLink)(({ theme }) => ({
  "&.MuiLink-root": {
    color: theme.colors.sapphire,
    fontFamily: theme.fonts.regular,
    fontSize: 14,

    "&:hover": {
      color: theme.colors.navy,
    },
  },
}));

const Link: FC<LinkProps> = (props) => {
  return <StyledLink underline="none" {...props} />;
};

export default Link;
